module.exports = __webpack_public_path__ + "static/media/icon-teamplayers-edit.76c1ff7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teamplayers-edit.svg
// module id = 1905
// module chunks = 0